export class BigQueryIntegrationConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataset",
            "baseName": "dataset",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BigQueryIntegrationConfig.attributeTypeMap;
    }
    constructor() {
    }
}
